<template>
  <v-container>
    <v-layout>
      <v-flex md8 sm10 xs12 offset-md2 offset-sm1>
        <v-card>
          <v-card-title>
            {{ (serverInfo && serverInfo.virtualserverName) || "TeamSpeak" }}
            <v-spacer></v-spacer>
            <span v-if="metaText" style="font-size: 12px; opacity: 0.7">
              {{ metaText }}
            </span>
          </v-card-title>

          <v-card-text>
            <div @contextmenu.prevent>
              <v-treeview :items="channelTree" :open="itemIDs" dense>
                <template #label="{ item }">
                  <!-- CHANNEL -->
                  <span
                    v-if="item.channelName"
                    class="pub-label"
                    :class="spacerClass(item.channelName)"
                  >
                    <!-- spacer ise fake-fill kullan -->
                    <span
                      v-if="isStarSpacer(item.channelName)"
                      class="pub-channel-text pub-spacer-fill-text"
                      :data-fill="spacerFill(item.channelName)"
                    ></span>

                    <!-- normal channel / lspacer / cspacer / rspacer tek bas -->
                    <span v-else class="pub-channel-text">
                      {{ prettyChannelName(item.channelName) }}
                    </span>
                  </span>

                  <!-- CLIENT -->
                  <span
                    v-else
                    class="pub-label pub-client"
                    :class="{
                      'is-talking': Number(item.clientFlagTalking || 0) === 1,
                      'is-away': Number(item.clientAway || 0) === 1,
                    }"
                  >
                    <v-icon small class="pub-client-ico">{{
                      clientIcon(item)
                    }}</v-icon>
                    <span class="pub-client-text">
                      <span
                        v-if="clientTags(item).length"
                        class="pub-tag-plain"
                      >
                        {{ clientTags(item).join(" ") }}
                      </span>
                      {{ item.clientNickname || item.name }}
                    </span>
                  </span>
                </template>
              </v-treeview>

              <div v-if="errorText" class="pub-error">
                {{ errorText }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const SITE_ORIGIN =
  typeof window !== "undefined" && window.location
    ? window.location.origin
    : "";

const BASE = (process.env.VUE_APP_BASE_PATH || "").replace(/\/$/, "");

const API = (p) => `${BASE}${p.startsWith("/") ? "" : "/"}${p}`;
export default {
  data() {
    return {
      serverInfo: {},
      channelList: [],
      clientList: [],
      itemIDs: [],
      channelTree: [],
      serverGroupList: [],
      errorText: "",
      _pollTimer: null,
      _abort: null,
      lastTs: 0,
      sid: 1,
    };
  },

  computed: {
    metaText() {
      const si = this.serverInfo || {};
      const online = si.virtualserverClientsOnline;
      const max = si.virtualserverMaxClients;
      if (typeof online === "number" && typeof max === "number")
        return online + "/" + max;
      return "";
    },
  },

  methods: {    clientTags(c) {
      const raw = String(c.clientServergroups || "");
      if (!raw) return [];

      const sgids = raw
        .split(",")
        .map((x) => Number(x.trim()))
        .filter((n) => Number.isFinite(n) && n > 0);

      const list = Array.isArray(this.serverGroupList)
        ? this.serverGroupList
        : [];
      const map = new Map(list.map((g) => [Number(g.sgid), g]));

      // sadece namemode açık olanlar
      const candidates = sgids
        .map((id) => map.get(id))
        .filter(
          (g) =>
            g && Number(g.namemode || 0) !== 0 && String(g.name || "").trim()
        );

      // sortid ile TS mantığına yakın sırala
      candidates.sort((a, b) => (a.sortid || 0) - (b.sortid || 0));

      // isim listesi (duplicate temizle)
      const names = [];
      for (const g of candidates) {
        const n = String(g.name || "").trim();
        if (n && !names.includes(n)) names.push(n);
      }

      // çok uzamasın diye max 3 tag
      return names.slice(0, 3).map((n) => `[${n}]`);
    },

    // ---------- spacer helpers ----------
    isStarSpacer(name) {
      return /^\[\*spacer[^\]]*\]/i.test(String(name || ""));
    },

    spacerClass(name) {
      const m = String(name || "").match(
        /^\[(\*spacer|lspacer|cspacer|rspacer)[^\]]*\]/i
      );
      if (!m) return "";
      const t = m[1].toLowerCase();

      if (t === "cspacer") return "pub-spacer pub-spacer-center";
      if (t === "lspacer") return "pub-spacer pub-spacer-left";
      if (t === "rspacer") return "pub-spacer pub-spacer-right";
      if (t === "*spacer") return "pub-spacer pub-spacer-fill";

      return "pub-spacer";
    },

    prettyChannelName(name) {
      name = String(name || "");
      const m = name.match(
        /^\[(\*spacer|lspacer|cspacer|rspacer)[^\]]*\](.*)$/i
      );
      if (!m) return name;

      const type = (m[1] || "").toLowerCase();
      let body = (m[2] || "").trim().replace(/^`+/, "").trim();
      if (!body) return "";

      // ✅ *spacer'ı template'te özel basıyoruz (fill). burada boş dön.
      if (type === "*spacer") return "";

      // l/c/r spacer: TEK BAS
      return body;
    },
    clientIcon(c) {
      const talking = Number(c.clientFlagTalking || 0) === 1;
      const inMuted = Number(c.clientInputMuted || 0) === 1;
      const outMuted = Number(c.clientOutputMuted || 0) === 1;
      const away = Number(c.clientAway || 0) === 1;

      if (talking && !inMuted) return "mdi-hexagon-slice-6"; // konuşuyor
      if (inMuted) return "mdi-microphone-off"; // mic kapalı
      if (outMuted) return "mdi-volume-mute"; // ses kapalı
      if (away) return "mdi-sleep"; // away
      return "mdi-hexagon-outline"; // normal
    },

    spacerFill(name) {
      // *spacer için TS client hissi: 1 satır dolusu tekrar string üret
      name = String(name || "");
      const m = name.match(/^\[\*spacer[^\]]*\](.*)$/i);
      if (!m) return "";
      let body = (m[1] || "").trim().replace(/^`+/, "").trim();
      if (!body) return "";

      // çizgi tipi ayırıcılar: her zaman ━ kullan (kesik olmasın)
      if (body === "━" || body === "-" || body === "—" || body === "_") {
        return "━".repeat(600);
      }

      // desenler (◣=●=◥ gibi): tekrar et
      let out = "";
      while (out.length < 600) out += body;
      return out.slice(0, 600);
    },

    // ---------- tree build ----------
    createNestedList(list, itemID = 0) {
      let out = [];
      for (let item of list) {
        if (item.parentItemId == itemID) {
          let children = this.createNestedList(list, item.itemId);
          if (children.length) item.children = children;
          out.push(item);
        }
      }
      return out;
    },

    openAllChannels() {
      this.itemIDs = [];
      this.channelList.forEach((channel) =>
        this.itemIDs.push(`${channel.cid}-channel`)
      );
    },

    mergedList(clientlist, channellist) {
      return [...clientlist, ...channellist].map((item) => {
        if (item.clientNickname) {
          return {
            id: `${item.clid}-client`,
            name: item.clientNickname,
            parentItemId: item.cid,
            itemId: null,
            ...item,
          };
        } else {
          return {
            id: `${item.cid}-channel`,
            name: item.channelName,
            itemId: item.cid,
            parentItemId: item.pid,
            ...item,
          };
        }
      });
    },

    // ---------- fetch/poll ----------
    async fetchPublic() {
      try {
        if (this._abort) this._abort.abort();
      } catch (_) {}
      this._abort = new AbortController();

      const url = API(`/api/public/tsview?sid=${encodeURIComponent(this.sid)}`);
      const res = await fetch(url, {
        signal: this._abort.signal,
        cache: "no-store",
      });
      const json = await res.json().catch(() => null);

      if (!res.ok || !json || json.ok !== true) {
        const detail =
          json && (json.detail || json.error)
            ? ` (${json.detail || json.error})`
            : "";
        throw new Error(`Public view failed${detail}`);
      }

      if (json.ts && json.ts === this.lastTs) return;

      this.lastTs = json.ts || Date.now();
      this.serverInfo = json.serverInfo || {};
      this.channelList = Array.isArray(json.channelList)
        ? json.channelList
        : [];
      this.clientList = Array.isArray(json.clientList) ? json.clientList : [];
      this.serverGroupList = Array.isArray(json.serverGroupList)
        ? json.serverGroupList
        : [];
      this.channelTree = this.createNestedList(
        this.mergedList(this.clientList, this.channelList)
      );
      this.openAllChannels();

      this.errorText = "";
    },

    startPolling() {
      if (this._pollTimer) clearInterval(this._pollTimer);

      this.fetchPublic().catch((e) => {
        this.errorText = e && e.message ? e.message : "Public view error";
      });

      this._pollTimer = setInterval(() => {
        this.fetchPublic().catch((e) => {
          this.errorText = e && e.message ? e.message : "Public view error";
        });
      }, 2500);
    },
  },

  created() {
    const sid = Number(this.$route.params.sid || 1);
    this.sid = Number.isFinite(sid) && sid > 0 ? sid : 1;
    this.startPolling();
  },

  beforeDestroy() {
    try {
      if (this._pollTimer) clearInterval(this._pollTimer);
    } catch (_) {}
    try {
      if (this._abort) this._abort.abort();
    } catch (_) {}
  },
};
</script>

<style>
/* satır sıkılığı */
.v-treeview-node__root {
  min-height: 16px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.v-list-item {
  min-height: 16px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.v-treeview-node__content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.v-list-item__content {
  padding: 0 !important;
}

/* label */
.pub-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* client */
.pub-client-ico {
  opacity: 0.9;
}
.pub-client-text {
  font-weight: 600;
  opacity: 0.95;
}

/* spacer genel: tek satır + taşanı kes */
.pub-spacer .pub-channel-text {
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  font-family: "DejaVu Sans Mono", "Noto Sans Mono", "Consolas", monospace !important;
  font-variant-ligatures: none;
  letter-spacing: 0;
}

/* l/c/r spacer hizaları */
.pub-spacer-center {
  display: block;
  width: 100%;
}
.pub-spacer-center .pub-channel-text {
  text-align: center;
}
.pub-spacer-left .pub-channel-text {
  text-align: left;
}
.pub-spacer-right .pub-channel-text {
  text-align: right;
}

/* *spacer: fill string'i before ile bas */
.pub-spacer-fill-text::before {
  content: attr(data-fill);
  display: block;
  width: 100%;
  text-align: center;
  white-space: nowrap;
}

/* hata */
.pub-error {
  margin-top: 10px;
  font-size: 12px;
  opacity: 0.8;
}
.v-treeview-node__root,
.v-list-item {
  min-height: 16px !important;
}

.v-treeview-node__content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.pub-channel-text,
.pub-client-text {
  line-height: 1;
}
/* Kanal metni biraz soluk */
.pub-channel-text {
  opacity: 0.65;
  font-weight: 500;
}

/* Kullanıcı metni belirgin */
.pub-client-text {
  opacity: 1;
  font-weight: 700;
}

/* Kullanıcı ikonu belirgin (beyazdan biraz ayrışsın) */
.pub-client-ico {
  opacity: 0.95;
}

/* Konuşan kullanıcı daha da belirgin olsun */
.pub-client.is-talking .pub-client-text {
  font-weight: 800;
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.25);
}
.pub-client.is-talking .pub-client-ico {
  transform: scale(1.08);
}

/* Away olan biraz soluk/italik */
.pub-client.is-away .pub-client-text {
  opacity: 0.6;
  font-style: italic;
}
.pub-tag {
  display: inline-block;
  margin-right: 6px;
  padding: 0 6px;
  border-radius: 8px;
  font-size: 12px;
  opacity: 0.85;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
</style>
